import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../../../../web/components-v2/Theme/theme';
import BoozeCruiseImageUrl from './boozeCruiseSpinRowBackground.png';
import GoldRushImageUrl from './goldRushSpinRowBackground.png';
import HighScoreImageUrl from './highScoreSpinRowBackground.png';

const { colors, typography, common } = THEME;
const rowHeight = 80;
const logoImageHeight = 64;
const logoImageWidth = 400;

const logoTile = {
	backgroundPosition: 'left bottom',
	backgroundRepeat: 'no-repeat',
	backgroundSize: 'contain',
	flex: 'none',
	height: logoImageHeight,
	width: logoImageWidth,
} as const;

export const styleSheet = StyleSheet.create({
	boozeCruiseLogo: { ...logoTile, backgroundImage: `url(${BoozeCruiseImageUrl})` },
	container: {
		boxSizing: 'border-box',
		position: 'relative',
	},
	contentColumn: {
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[20],
		listStyle: 'none',
		margin: 0,
		padding: 0,
	},
	goldRushLogo: { ...logoTile, backgroundImage: `url(${GoldRushImageUrl})` },
	highScoreLogo: { ...logoTile, backgroundImage: `url(${HighScoreImageUrl})` },
	history: {
		marginTop: SPACE[20],
	},
	historyRow: {
		alignItems: 'center',
		backgroundColor: colors.background.light,
		border: `1px solid ${colors.border.light}`,
		borderRadius: common.borderRadius,
		boxSizing: 'border-box',
		color: colors.text.main,
		display: 'flex',
		fontSize: typography.fontSizes.md,
		gap: SPACE[40],
		height: rowHeight,
		padding: `0 ${SPACE[28]}px`,
		width: '100%',
	},
	historyRowFieldWithLabel: {
		alignItems: 'center',
		display: 'flex',
		gap: SPACE[8],
	},
	historyRowLabel: {
		color: colors.text.light,
		fontSize: typography.fontSizes.xxs,
		fontWeight: typography.fontWeights.semibold,
		letterSpacing: '1.1px',
		textTransform: 'uppercase',
	},
	historyRowPrize: {
		color: colors.success.dark,
		fontSize: typography.fontSizes.lg,
		fontWeight: typography.fontWeights.bold,
		width: 150,
	},
	historyRowSymbol: {
		height: SPACE[16],
		width: 'auto',
	},
	historyRowSymbols: {
		display: 'flex',
		width: 120,
	},
	spinRow: {
		height: rowHeight,
		paddingBottom: 0,
		paddingTop: 0,
		justifyContent: 'flex-start',
		width: '100%',
	},
	spinRowContent: {
		alignItems: 'center',
		display: 'flex',
		gap: SPACE[16],
		width: '100%',
	},
	spinRowText: {
		flex: 1,
		fontSize: typography.fontSizes.md,
		fontWeight: typography.fontWeights.standard,
		textAlign: 'right',
		whiteSpace: 'normal',
	},
	spinRowCount: {
		fontWeight: typography.fontWeights.bold,
	},
});
